import { page, type FeatureRoutes } from "@/app/feature";

export const routes: FeatureRoutes = {
  fullscreen: [
    { path: "reveal/:captureId", lazy: page(() => import("./RevealPage")) },
    // Replay from the card detail (screens-collection links here).
    { path: "reveal/card/:cardId", lazy: page(() => import("./ReplayPage")) },
  ],
};
